import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ApiService } from "../../../services/api.service";
import { UserService } from "../../../services/user.service";
import { UserStorageService } from "../../../services/user-storage.service";

@Component({
	selector: "app-start",
	templateUrl: "./start.component.html",
	styleUrls: ["./start.component.scss"],
	imports: [TranslatePipe],
})
export class StartComponent implements OnInit {
	private userStorageService = inject(UserStorageService);
	private apiService = inject(ApiService);
	private userdataService = inject(UserService);
	private router = inject(Router);

	lang = this.userStorageService.getLanguage();
	public translate: TranslateService;
	public userFirstname: any;

	constructor() {
		const translate = inject(TranslateService);

		this.translate = translate;
	}

	ngOnInit(): void {
		if (Capacitor.isNativePlatform()) {
			this.router.navigate(["link/mobile"]);
			return;
		}

		this.apiService.CheckLogin();
		this.translate.use(this.lang.shortcode);
		const user = this.userdataService.getUser();
		if (user) {
			this.userFirstname = user.Firstname;
		}
	}

	navigateTo = (page: string) => {
		switch (page) {
			case "home":
				this.router.navigate(["home"]);
				break;
		}
	};
}
